/**
 * @generated SignedSource<<754a22047afd49ac724a21b2ed5d4780>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductImageOnly_item$data = {
  readonly productPhotos: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ProductImage_photo">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImage_item">;
  readonly " $fragmentType": "BuyerProductImageOnly_item";
};
export type BuyerProductImageOnly_item$key = {
  readonly " $data"?: BuyerProductImageOnly_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductImageOnly_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductImageOnly_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImage_item"
    },
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductImage_photo"
        }
      ],
      "storageKey": "photos(limit:1)"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e0ad8aec114c3ec7bd0da37fac3929a2";

export default node;
